//noScroll
class ScrollEl {
  constructor(el,opt){
    this.el = $("." + el);
    if(this.el.length > 0){
      this.event();
    }
  }
  event(){

    gsap.to(".js-scrollMv", 
    {
      ease: "power1.out",
      scrollTrigger: {
        trigger: ".js-scrollMv",
        start: () => `0px`,
        end: () => `800px`,
        pin: true,
        // markers: true
      }
    })

    gsap.to(".js-scrollMv-hidden", 
    {
      opacity: 0,
      ease: "power1.out",
      scrollTrigger: {
        trigger: ".js-scrollMv-trigger",
        start: () => `100px`,
        end: () => `300px`,
        scrub: 0.1,
        // markers: true
      }
    })

    gsap.to(".js-scrollMv-text, .js-scrollMv-bg", 
    {
      opacity: 1,
      ease: "power1.out",
      scrollTrigger: {
        trigger: ".js-scrollMv-trigger",
        start: () => `300px`,
        end: () => `500px`,
        scrub: 0.1,
        // markers: true
      }
    })
  }
}